import actions from './actions';
import { exportCommonFile } from "../../../../helpers/utilities";

const initState = {
    loader: false,
    supplierDetails: '',
    error: '',
    purchaseSelfBillDetails: '',
    supplierPaymentDetails: '',
    purchasedPrice: '',
    purchasedLoader: '',
    supplierBankDetails: '',
};

export default function purchaseManagementReducer(state = initState, action) {
    switch (action.type) {
        case actions.SUPPLIER_DETAILS_START: {
            return {
                ...state,
                loader: true,
                supplierDetails: '',
            };
        }
        case actions.SUPPLIER_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                supplierDetails: action.payload,
            };
        }
        case actions.SUPPLIER_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.PURCHASE_SELFBILL_DETAILS_START: {
            return {
                ...state,
                loader: true
            };
        }
        case actions.PURCHASE_SELFBILL_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                purchaseSelfBillDetails: action.payload,
            };
        }
        case actions.PURCHASE_SELFBILL_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.SUPPLIER_PAYMNET_DETAILS_START: {
            return {
                ...state,
                loader: true
            };
        }
        case actions.SUPPLIER_PAYMNET_DETAILS_SUCCESS: {
            if (action.export) {
                exportCommonFile(action.export, action.payload, action.data, action.selected, action.extension);
            }
            return {
                ...state,
                loader: false,
                supplierPaymentDetails: action.payload
            };
        }
        case actions.SUPPLIER_PAYMNET_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.SUPPLIER_INVOICE_DETAILS_START: {
            return {
                ...state,
                loader: true
            };
        }
        case actions.SUPPLIER_INVOICE_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                supplierInvoiceDetails: action.payload,
            };
        }
        case actions.SUPPLIER_INVOICE_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }

        case actions.SUPPLIER_BANK_DETAILS_START: {
            return {
                ...state,
                loader: true
            };
        }
        case actions.SUPPLIER_BANK_DETAILS_SUCCESS: {
            return {
                ...state,
                loader: false,
                supplierBankDetails: action.payload,
            };
        }
        case actions.SUPPLIER_BANK_DETAILS_FAILURE: {
            return {
                ...state,
                loader: false,
                error: action.message,
            };
        }
        case actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_START: {
            return initState;
        }
        case actions.CLEAR_PURCHASE_MANAGEMENT_DETAILS_SUCCESS: {
            return initState;
        }

        default:
            return state;
    }
}